/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import Divider from '@mui/material/Divider';
import { X } from 'react-feather';
/**
 * Modal common component that uses across modules for display warning and confirmation messages
 * @param {*} props
 * @returns
 */
const Modal = (props) => {
  //
  const {
    open,
    handleClose,
    title,
    content,
    handleSuccess,
    closeLabel,
    successLabel,
    color,
    variant,
  } = props;
  //
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {title}
        <IconButton
          size="small"
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <X />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent id="alert-dialog-description" sx={{ whiteSpace: 'pre-line' }}>
        {content}
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'space-around',
          pb: 5,
        }}
      >
        <Button sx={{ px: 10 }} onClick={handleClose} variant="outlined" color="primary">
          {closeLabel}
        </Button>
        <Button sx={{ px: 10 }} onClick={handleSuccess} color={color} variant={variant} autoFocus>
          {successLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
//
export default Modal;
